import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import Card from './Card';
import useIsMobile from 'hooks/useIsMobile';
import { Apps } from 'constants/global';
import {
  blogWriterSteps,
  chatWithDocsSteps,
  botBuilderSteps,
  emailGeneratorSteps,
  textToLogoSteps,
  gifMakerSteps,
  transcriptGeneratorSteps,
  textToSpeechSteps,
  upscaleImageSteps,
  objectRemoverSteps,
  objectReplacerSteps,
  brandbookSteps,
  podcastSteps,
  socialMediaSteps,
  stickerMakerSteps,
  imageToImageSteps,
  textToImageSteps,
} from 'constants/steps.constant';

export interface HowToStepsCardProps {
  howToTitle: string;
  appType: Apps;
}

const stepsMap = {
  [Apps.BLOG_WRITER]: blogWriterSteps,
  [Apps.CHAT_WITH_DOCS]: chatWithDocsSteps,
  [Apps.BOT_BUILDER]: botBuilderSteps,
  [Apps.EMAIL_GENERATOR]: emailGeneratorSteps,
  [Apps.TEXT_TO_LOGO]: textToLogoSteps,
  [Apps.TEXT_TO_IMAGE]: textToImageSteps,
  [Apps.GIF_MAKER]: gifMakerSteps,
  [Apps.TRANSCRIPT_GENERATOR]: transcriptGeneratorSteps,
  [Apps.TEXT_TO_SPEECH]: textToSpeechSteps,
  [Apps.UPSCALE_IMAGE]: upscaleImageSteps,
  [Apps.OBJECT_REMOVER]: objectRemoverSteps,
  [Apps.OBJECT_REPLACER]: objectReplacerSteps,
  [Apps.BRANDBOOK]: brandbookSteps,
  [Apps.PODCAST]: podcastSteps,
  [Apps.SOCIAL_MEDIA]: socialMediaSteps,
  [Apps.STICKER_MAKER]: stickerMakerSteps,
  [Apps.IMAGE_TO_IMAGE]: imageToImageSteps,
};

const HowToStepsCard = ({ howToTitle, appType }: HowToStepsCardProps) => {
  const isMobile = useIsMobile();

  const steps = stepsMap[appType as keyof typeof stepsMap];

  return (
    <div className="flex flex-col gap-4 p-0 md:p-4 pb-8 md:pt-8 m-4 mb-0 rounded-lg bg-background-secondary max-w-full md:max-w-[1260px]">
      <h2 className="text-xl md:text-[28px] font-semibold text-text-primary my-1 md:mb-3 text-center">
        {howToTitle}{' '}
        <span className="bg-gradient-to-r from-[#9747ff] via-[#7c66ff] to-[#6087ff] bg-clip-text text-transparent">
          Kreaitor AI
        </span>
      </h2>
      {isMobile ? (
        <Carousel
          showArrows={false}
          showStatus={false}
          showThumbs={false}
          infiniteLoop={false}
        >
          {steps.map((step, index) => (
            <Card key={step.title} step={index + 1} {...step} />
          ))}
        </Carousel>
      ) : (
        <div className="flex flex-row gap-4 md:gap-6 pb-8">
          {steps?.map((step, index) => (
            <Card key={step.title} step={index + 1} {...step} />
          ))}
        </div>
      )}
    </div>
  );
};

export default HowToStepsCard;
